// Vendors
import { objectUtils } from '@openbank/cf-ui-architecture-core';
// Services
import {
  fetchLanguagesConfigurationService,
  fetchLanguageService,
} from '../services/internationalization.services';
// Types
import { InternationalizationResolverType } from './types/internationalization.resolvers.type';
// Utils
import { isValidLanguageConfiguration } from './utils/internationalization.resolvers.utils';

const fetchLanguagesConfigurationResolver = async (
  language: string
): InternationalizationResolverType => {
  const [response] = await fetchLanguagesConfigurationService(language);
  return isValidLanguageConfiguration(response) ? [response, false] : [null, true];
};

const fetchLanguageResolver = async (url: string): InternationalizationResolverType => {
  const [{ entries = null } = {}] = await fetchLanguageService(url);
  return objectUtils.isValidObject(entries) ? [entries, false] : [null, true];
};

export { fetchLanguageResolver, fetchLanguagesConfigurationResolver };
